import { Injectable }                 from '@angular/core';
import { HttpClient }                 from '@angular/common/http';
import { Router, Resolve, RouterStateSnapshot,
         ActivatedRouteSnapshot }     from '@angular/router';

import { Observable }                 from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/zip';
import 'rxjs/add/operator/map';

@Injectable()
export class ProjectResolver implements Resolve<any> {

  constructor(private http: HttpClient, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    while (route.routeConfig.path !== ':project_id') {
      route = route.parent;
    }
    let id = route.paramMap.get('project_id');
    return this.http.get(`/data/art/${id}.json`);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/art/project-resolver.service.ts